const BASE = '/v1/station';

/**
 * @typedef {Object} StationCreateDto
 * @property {string} stationCode
 * @property {string} stationName
 * @property {number} stationTypeId
 * @property {number} warehouseId
 * @property {number|null} zoneId
 * @property {number|null} capacity
 * @property {number|null} hourlyRate
 */

/**
 * @typedef {Object} UserStationCreateDto
 * @property {string} userId
 * @property {string|null} skillLevel
 * @property {string|null} certificationDate
 */

export default (instance) => ({
  getStations: (params) => instance.get(BASE, { params }),
  getStation: (id) => instance.get(`${BASE}/${id}`),
  getLookups: () => instance.get(`${BASE}/lookups`),
  getUserLookups: () => instance.get(`${BASE}/user-lookups`),
  createStation: (data) => instance.post(BASE, data),
  updateStation: (id, data) => instance.put(`${BASE}/${id}`, data),
  deleteStation: (id) => instance.delete(`${BASE}/${id}`),

  // User-Station assignments
  getStationUsers: (stationId, params) => instance.get(`${BASE}/${stationId}/users`, { params }),
  assignUser: (stationId, data) => instance.post(`${BASE}/${stationId}/users`, data),
  updateUserAssignment: (stationId, userStationId, data) => instance.put(`${BASE}/${stationId}/users/${userStationId}`, data),
  removeUser: (stationId, userStationId) => instance.delete(`${BASE}/${stationId}/users/${userStationId}`),

  // Production Floor Monitor
  getFloorStatus: () => instance.get(`${BASE}/floor-status`),
  getLayout: () => instance.get(`${BASE}/layout`),
  updateLayoutPosition: (stationId, payload) => instance.put(`${BASE}/layout/${stationId}/position`, payload)
});
